import { gql } from "@apollo/client";
import { ButtonBase } from "@mui/material";
import Grid from "atoms/Grid";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import Section from "molecules/Section";
import React, { useState } from "react";

import EventCard, { EventCardFragment } from "./EventCard";

export const GameOverviewHighlightsFragment = gql`
  fragment GameOverviewHighlightsFragment on Game {
    id
  }
`;

const INITIAL_COUNT = 6;

export default function GameOverviewHighlights({ gamePlayer }) {
  const [showAll, setShowAll] = useState(false);

  const [data] = useData(
    gql`
      query GameOverviewHighlights($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          events {
            id
            ...EventCardFragment
          }
        }
      }
      ${EventCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  const events = data?.gamePlayer?.events ?? [];

  if (!events.length) {
    return null;
  }

  const displayedEvents = showAll ? events : events.slice(0, INITIAL_COUNT);
  const hasMore = events.length > INITIAL_COUNT;

  return (
    <Section title="HIGHLIGHTS">
      <Grid gridItemWidth="160px">
        {displayedEvents.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </Grid>
      {hasMore && (
        <ButtonBase
          onClick={() => setShowAll((prev) => !prev)}
          style={{
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontSize: "0.8rem",
            fontWeight: 400,
            color: "#9e9e9e",
            padding: `${SPACING} 0`,
          }}
        >
          {showAll ? "Show Less" : `Show More (${events.length - INITIAL_COUNT} more)`}
        </ButtonBase>
      )}
    </Section>
  );
}
